import React, { useEffect, useRef, useState } from 'react';

interface Props {
  value: string;
  onSave: (name: string) => void;
  forceEditCount?: number;
}

const EditableName: React.FC<Props> = ({ value, onSave, forceEditCount = 0 }) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value);
  const prevCount = useRef(forceEditCount);

  useEffect(() => {
    if (forceEditCount !== prevCount.current) {
      prevCount.current = forceEditCount;
      setDraft(value);
      setEditing(true);
    }
  }, [forceEditCount, value]);

  const commit = () => {
    if (draft.trim()) onSave(draft.trim());
    else setDraft(value);
    setEditing(false);
  };

  if (editing) {
    return (
      <input
        className="name-input"
        value={draft}
        autoFocus
        onChange={e => setDraft(e.target.value)}
        onBlur={commit}
        onKeyDown={e => { if (e.key === 'Enter') commit(); if (e.key === 'Escape') { setDraft(value); setEditing(false); } }}
        onClick={e => e.stopPropagation()}
      />
    );
  }

  return (
    <span
      className="name-text"
      style={{ cursor: 'text' }}
      title="Click to rename"
      onClick={e => { e.stopPropagation(); setEditing(true); setDraft(value); }}
    >
      {value}
    </span>
  );
};

export default EditableName;
